import { create } from 'zustand';
import { IUIState, INotification } from '../types/interfaces/IUI';
import { config } from '../config/environment';

// Cache para evitar notificaciones duplicadas
const notificationCache = new Map<string, number>();
const DEBOUNCE_TIME = 5000; // 5 segundos entre notificaciones similares

export const useUIStore = create<IUIState>((set, get) => ({
  sidebarOpen: true,
  currentPage: 'dashboard',
  notifications: [],

  toggleSidebar: () => {
    set(state => ({ sidebarOpen: !state.sidebarOpen }));
  },

  setCurrentPage: (page: string) => {
    set({ currentPage: page });
  },

  addNotification: notification => {
    // Crear una clave única para la notificación
    const notificationKey = `${notification.type}-${notification.title}-${notification.message}`;
    const now = Date.now();
    const lastNotification = notificationCache.get(notificationKey);

    // Si es una notificación de error y se mostró recientemente, no mostrar
    if (
      notification.type === 'error' &&
      lastNotification &&
      now - lastNotification < DEBOUNCE_TIME
    ) {
      console.warn('Notification suppressed (debounced):', notificationKey);
      return;
    }

    // Actualizar el cache
    notificationCache.set(notificationKey, now);

    const id = Math.random().toString(36).substr(2, 9);
    const newNotification: INotification = {
      ...notification,
      id,
      duration: notification.duration || config.notifications.duration,
    };

    set(state => ({
      notifications: [...state.notifications, newNotification],
    }));

    // Auto-remove notification after duration
    if (newNotification.duration) {
      setTimeout(() => {
        get().removeNotification(id);
      }, newNotification.duration);
    }
  },

  removeNotification: (id: string) => {
    set(state => ({
      notifications: state.notifications.filter(n => n.id !== id),
    }));
  },

  clearNotifications: () => {
    set({ notifications: [] });
  },
}));
